import  React, { Component } from 'react';
import { Row, Col } from "reactstrap";
import OperationsOrdersTable from "../Operations/Orders/OrdersTable";
import Registry from "../../Utils/Registry";


class HomeOrders extends Component {
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.state = {
            orders_coming: [],
            orders_done: [],
            activeTable: "coming",
            disabledTable: "done"
        };

        this.loadOrders = this.loadOrders.bind(this);
        this.toggleTable = this.toggleTable.bind(this);
    }

    loadOrders(delivered=0){
        const orderDirection = delivered === 0 ? "" : "_desc";
        this.api.get(`/orders?is_business=1&per_page=3&order_by${orderDirection}=start_datetime&delivered=${delivered}`)
            .then(results => {
                let s = {};
                if(delivered===0)
                    s = {orders_coming: results.results};
                else
                    s = {orders_done: results.results};

                this.setState(s);
            });
    }

    toggleTable(i){
        if (i == 0)
            this.setState({
                activeTable: "coming",
                disabledTable: "done"
            });
        else
            this.setState({
                activeTable: "done",
                disabledTable: "coming"
            });
    }

    componentDidMount(){
        this.loadOrders(0);
        this.loadOrders(1);
    }

    render() {
        return <div>
            {/* PC's display */}
            <Row className="hide-below-lg">
                <Col xl="12">
                    <h2 className="ty-subtitle">Prochains ravitaillements</h2>

                    <OperationsOrdersTable
                        orderStatus="coming"
                        orders={this.state.orders_coming}
                        refreshAfterDelete={ () => { this.loadOrders(0); }}
                    />
                </Col>

                <Col xl="12">
                    <h2 className="ty-subtitle">Derniers ravitaillements</h2>

                    <OperationsOrdersTable
                        orders={this.state.orders_done}
                        refreshAfterDelete={ () => { this.loadOrders(1); }}
                    />
                </Col>
            </Row>

            {/* Tablet's display */}
            <Row className="display-below-lg">
                <Col xs="12" sm="12">
                    <h2 className="ty-subtitle row">
                        <Col xs="6" sm="5" className={"display-inline-block text-center-below-sm " + (this.state.activeTable === "coming" ? "" : "gray_dark pointer")} onClick={() => {this.toggleTable(0)}}>
                            Prochains ravitaillements
                        </Col>
                        <Col xs="6" sm="6" className={"display-inline-block text-center-below-sm " + (this.state.activeTable === "coming" ? "gray_dark pointer" : "")} onClick={() => {this.toggleTable(1)}} style={{paddingLeft: 0}}>
                            Derniers ravitaillements
                        </Col>
                    </h2>

                    <OperationsOrdersTable
                        orderStatus={this.state.activeTable}
                        orders={this.state.activeTable === "coming" ? this.state.orders_coming : this.state.orders_done}
                        refreshAfterDelete={ () => { this.loadOrders(this.state.activeTable === "coming" ? 0 : 1); }}
                    />
                </Col>
            </Row>
        </div>
    }
}

export default HomeOrders;



// WEBPACK FOOTER //
// ./src/components/Home/Orders.js